import Navbar from "../../components/navbar/index.jsx";
import ListaMonit from "../../components/ListaMonit/listamonit.jsx";
import  './monitoramento.css';

function Monitoramento(){
    return  <div>
          <Navbar/>
   
            <div className="container-fluid titulo" >
                 <ListaMonit/>
            </div>
    </div>

}
export default Monitoramento;
